module.exports = __webpack_public_path__ + "img/angle_down.eea7451e.svg";